import React, { useState } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import Modal from '../Modal';
import { HeaderContent, ActionsWrapper } from '../modal-elements';
import { HeaderShare, Duplicate } from '../../svg';

import { Button, TextInputWithIcon } from '../input-elements';

import log from '../../logger';

const CopyNotification = styled.p`
    opacity: ${(props) => (props.$show ? 1 : 0)};
    transition: opacity 0.5s;
    color: ${({ theme }) => theme.color.grey1};
    float: right;
`;

const FormStyled = styled.div`
    margin-top: 3em;
`;

// add color
const TextInputWithIconStyled = styled(TextInputWithIcon)`
    color: ${({ theme }) => theme.color.highlightColor};
`;

function SharePage({ handleClose, webPage, sharedKeyFromSpace }) {
    const [copied, setCopied] = useState(false);

    var url = webPage;


    if (sharedKeyFromSpace !== "empty") {
        url = webPage + "?publicKey=" + sharedKeyFromSpace;
        console.log("sharedKeyFromSpace : url is " + url);
    } else {
        url = webPage;
        console.log("loadedKeyFromSpace : url is " + url);
    }

    const copyToClipboard = () => {

        navigator.clipboard
            .writeText(url)
            .then(() => {
                setCopied(true);
            })
            .catch((err) => {
                log.error(err);
            });

    };

    return (
        <Modal>
            <HeaderContent title="Share this Space" Icon={HeaderShare}>
                Copy and paste this url to share this space
            </HeaderContent>

            <FormStyled>
                <label htmlFor="urlText" className="sr-only">
                    Copy
                </label>
                <TextInputWithIconStyled
                    id="urlText"
                    defaultValue={url}
                    Icon={Duplicate}
                    onIconClick={copyToClipboard}
                />

                <CopyNotification $show={copied}>Copied</CopyNotification>
            </FormStyled>

            <ActionsWrapper>
                <Button onClick={handleClose}>Close</Button>
            </ActionsWrapper>
        </Modal>
    );
}

SharePage.propTypes = {
    handleClose: propTypes.func.isRequired,
};
export default SharePage;
